import { IonAvatar, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonImg, IonPage, IonRow, IonText } from '@ionic/react';
import { basketOutline, cardOutline, chatboxOutline, ellipsisHorizontalCircleOutline, heartOutline, keyOutline, logOutOutline, peopleOutline } from 'ionicons/icons';
import { useState } from 'react';

import DetailItem from '../../../components/profile/DetailItem';
import Container from '../../../layouts/Container';
import Toolbar2 from '../../../layouts/Toolbar2';
import CardStatus from './CardStatus';
import ChangePassword from './Forms/ChangePassword';

import './LoggedIn.css';

interface Props {
    profile?: any,
    logOut: any
}

const LoggedIn: React.FC<Props> = (props) => {
    const [showCardStatusModal, setShowCardStatusModal] = useState(false);
    const [showChangPasswordModal, setChangPasswordModal] = useState(false);

    const showCardStatusHandler = () => {
        setShowCardStatusModal(true);
    }

    const hideCardStatusHandler = () => {
        setShowCardStatusModal(false);
    }

    const showChangePasswordHandler = () => {
        setChangPasswordModal(true);
    }

    const hideChangePasswordHandler = () => {
        setChangPasswordModal(false);
    }

    const startButton =
        <IonButtons slot="start">
            <IonButton shape="round" color="white" onClick={showChangePasswordHandler}>
                <IonIcon icon={keyOutline} />
            </IonButton>
        </IonButtons>

    const endButton =
        <IonButtons slot="end">
            <IonButton shape="round" color="white" onClick={props.logOut}>
                <IonIcon icon={logOutOutline} flipRtl />
            </IonButton>
        </IonButtons>

    return <IonPage className="profile-logged">
        <IonContent className="main-content">
            <Toolbar2 startButton={startButton} endButtons={endButton} />

            <Container className="top-section">
                <div>
                    <IonAvatar>
                        <IonImg src={props.profile?.avatar + '?' + new Date().getTime()} />
                    </IonAvatar>

                    <IonText className="name">{props.profile?.full_name}</IonText>
                    <IonText className="mobile">{props.profile?.mobile}</IonText>
                </div>
            </Container>

            <Container className="middle-section">
                <IonRow className="buttons">
                    <IonCol size="6">
                        <IonButton routerLink="/account/request-card" expand="block" color="secondary">کارت حامی طبیعت</IonButton>
                    </IonCol>
                    <IonCol size="6">
                        <IonButton routerLink="/account/monthly-pay" expand="block" color="danger">پرداخت ماهیانه</IonButton>
                    </IonCol>
                </IonRow>

                <IonCard>
                    <IonCardContent>
                        <IonRow>
                            <IonCol size="4">
                                <IonRow className="info-item">
                                    <IonIcon className="icon" color="primary" src={ellipsisHorizontalCircleOutline} />
                                    <IonText className="value">{props.profile?.unique_id}</IonText>
                                    <IonText className="title">شناسه کاربری</IonText>
                                </IonRow>
                            </IonCol>
                            <IonCol size="4">
                                <IonRow className="info-item">
                                    <IonIcon className="icon" color="primary" src={peopleOutline} />
                                    <IonText className="value">{props.profile?.rank}</IonText>
                                    <IonText className="title">رتبه حمایت</IonText>
                                </IonRow>
                            </IonCol>
                            <IonCol size="4" style={{border: "2px solid #eee", borderRadius: 15}}>
                                <IonRow onClick={showCardStatusHandler} className="info-item">
                                    <IonIcon className="icon" color="primary" src={cardOutline} />
                                    <IonText className="value">{props.profile?.card_status_text}</IonText>
                                    <IonText className="title">وضعیت کارت</IonText>
                                </IonRow>
                            </IonCol>
                        </IonRow>

                        <div className="ion-margin-top">
                            {props.profile?.new_message ? <IonButton routerLink="/account/messages" className="new-message-button" color="warning">
                                <IonText>پیام جدید دارید!</IonText>
                            </IonButton> : null}

                            {props.profile?.card_renew?.expired ? <IonButton href={props.profile?.card_renew?.link} target="_blank" className="new-message-button" color="danger">
                                <IonText>تمدید کارت حامی طبیعت</IonText>
                            </IonButton> : null}

                            <DetailItem link="/account/payments" icon={heartOutline} title="حمایت ها" />
                            <DetailItem link="/account/orders" icon={basketOutline} title="سفارش ها" />
                            <DetailItem link="/account/messages" icon={chatboxOutline} title="پیام ها" />
                        </div>
                    </IonCardContent>
                </IonCard>
            </Container>

            <ChangePassword show={showChangPasswordModal} hide={hideChangePasswordHandler} />
            <CardStatus show={showCardStatusModal} clickHide={hideCardStatusHandler} status={props.profile.card_status} tracking={props.profile.card_tracking} post_barcode={props.profile.card_barcode} issueDate={props.profile.card_issued_date} />
        </IonContent>
    </IonPage>;
}
export default LoggedIn